module.exports = __webpack_public_path__ + "assets/img/img102.8e1d0f51.png";